module.exports = __webpack_public_path__ + "img/tripadvisor_icon.a2e5646.png";